<template>
  <div class="page-width">
    <div v-if="this.isMobile" class="cart">
      <h2>{{ $t('yourCart') }}</h2>
      <el-form  ref="ruleForm">
        <table>
          <thead>
            <tr>
              <th colspan="3" scope="col">{{ $t('product') }}</th>
              <th scope="col">{{ $t('price') }}</th>
              <th scope="col">{{ $t('quantity') }}</th>
              <th scope="col" class="hidden-xs-only"> {{ $t('total') }}</th>
            </tr>
          </thead>
          <thead v-if="local" class="page-width-1" >
            <tr v-for="(item,index) in this.$store.state.cart.cartProductsList">
              <td class="cart__image-wrapper" ><img :src="item.Thumbnail" alt=""></td>
              <td class="cart__meta small--text-left">
                <p>{{item.Name}}</p>
                <p ><a v-on:click.prevent="deleteItem(item)" class="btn btn--secondary" href="">{{ $t('remove') }}</a></p>
              </td>
              <td class="cart__price-wrapper">
                ${{item.Price.toFixed(2)}}
              </td>
              <td class="text-right small--hide hidden-xs-only">
                <el-input v-on:change="updateItemCount($event, item)" v-model="item.quantity"></el-input>
              </td>
              <td class="text-center small--hide hidden-sm-and-up">{{item.quantity}}</td>
              <td class="text-right small--hide hidden-xs-only">{{localTotalPrice(item.Price, item.quantity)}}</td>
            </tr>
          </thead>
          <thead v-else class="page-width-1">
          <tr v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
            <td class="cart__image-wrapper" ><img :src="item.Thumbnail" alt=""></td>
            <td class="cart__meta small--text-left">
              <p>{{item.Name}}</p>
              <p ><a v-on:click.prevent="!itemDeletedLoading && deleteItem(item)" class="btn btn--secondary" href="">{{ $t('remove') }}</a></p>
            </td>
            <td class="cart__price-wrapper">
              ${{item.UnitPrice.toFixed(2)}}
            </td>
            <td class="text-right small--hide hidden-xs-only">
              <el-input v-on:change="updateItemCount($event, item)" v-model="item.Quantity"></el-input>
            </td>
            <td class="text-center small--hide hidden-sm-and-up">{{item.Quantity}}</td>
             <td class="text-right small--hide hidden-xs-only">${{item.TotalPrice.toFixed(2)}}</td>
          </tr>
          </thead>
        </table>
        <div class="cart__footer">
          <div class="cart__subtotal">
            <span class="cart__subtotal-title" v-if="loggedIn">{{ $t('subtotal') }}</span>
            <span class="cart__subtotal" v-if="loggedIn">{{calculateLocalSubtotal()}}</span>
          </div>
          <div class="cart__shipping rte">{{ $t('taxAndShipping') }}
          </div>
          <div class="cart__submit-controls">
            <a href="" class="btn btn--secondary ">{{ $t('continueShopping') }}</a>
          <button class="btn" v-if="local" @click="goToLogin()">{{ $t('checkOut') }}</button>
          <button @click="postCartItemsAndCheckout($event)" class="btn" v-else>{{ $t('checkOut') }}</button>
          </div>
        </div>
      </el-form>
    </div>
    <div v-else>           
      <div :style="'display: flex; justify-content: center; position: relative'"> 
      <table :style="'z-index: 6; background-color: white;'">
        <thead>
          <tr>
            <th :style="'padding: 20px; font-size: 24px'" colspan="3" scope="col">{{ $t('myCart') }}</th>
          </tr>
        </thead>
        <!-- logged in -->
        <div v-if="!local" >
          <thead >
            <tr :style="'padding-bottom: 30px'"  v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
              <td class="cart__image-wrapper" ><img @click="goToProductDetail(item)" :style="'height: 100px;'" :src="item.Thumbnail" alt=""></td>
              <td class="cart__meta small--text-left" :style="'font-size: 10px; padding-right: 5px; margin: auto'">
                <p :style="'font-size: 12px'">{{item.Name}}</p>
                  <p :style="'font-size: 12px'">${{item.UnitPrice.toFixed(2)}}</p>
              </td>
              <td>
                <div :style="'display: flex; flex-direction: column; justify-content: center; align-items: center'" >
                  <div :style="'display: flex; flex-direction: row; align-items: center'">
                    <button @click="updateItemCount($event, item)"  :style="'border-radius: 10px; height: 20px; width: 20px; background-color: #ffffff; font-family: Martian B Thai; color: #ff6f37; margin: 5px;font-size: 16px; line-height: 1;'" >-</button>
                    <p>{{item.Quantity}}</p>
                    <button @click="throttleAddToCart(item)" :style="'border-radius: 10px; height: 20px; width: 20px; background-color: #ff6f37; font-family: Martian B Thai; color: #ffffff;margin: 5px;    font-size: 16px; line-height: 1;'" >+</button>
                  </div>
                  <div :style="'cursor: pointer'"  >
                    <i v-on:click.prevent="!itemDeletedLoading && deleteItem(item)" class="fa fa-trash-o" :style="'padding-top: 10px; cursor: pointer'"  aria-hidden="true"></i>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <!-- logged in -->
            <div :style="'display: flex; justify-content: space-around; align-items: center; padding: 10px; box-shadow: 1px -5px 15px -5px #e6e3e3;'">
              <div :style="' display: flex; flex-direction: column;'" >
                <span :style="'font-size: 16px;'" >{{ $t('subtotal') }}({{this.$store.state.cart.cartProductsList.TotalCount}} {{ $t('items') }})</span>
                <span :style="'font-size: 12px;'" >{{ $t('taxAndShipping') }}</span>
                <span :style="'font-size: 16px'" v-if="loggedIn">${{calculateLocalSubtotal()}} </span> 
              </div>
              <div :style="'width: 150px;'">
              <button @click="postCartItemsAndCheckout($event)" class="btn" >{{ $t('checkOut') }}</button>
              </div>
            </div>
          </div>
          <!-- not logged in -->
          <div v-else >
         <thead>
          <tr :style="'padding-bottom: 30px'" v-for="(item,index) in this.$store.state.cart.cartProductsList">
            <td class="cart__image-wrapper" ><img @click="goToProductDetail(item)" :style="'height: 100px;'" :src="item.Thumbnail" alt=""></td>
            <td class="cart__meta small--text-left" :style="'font-size: 10px; padding-right: 5px; margin: auto'">
              <p>{{item.Name}}</p>
              <p>${{item.Price}}</p>
            </td>
            <td>
              <div :style="'display: flex; flex-direction: column; justify-content: center; align-items: center'"  class="qty_input">
                <div :style="'display: flex; flex-direction: row; align-items: center'">
                  <button @click="updateItemCount($event, item)"  :style="'border-radius: 10px; height: 20px; width: 20px; background-color: #ffffff; font-family: Martian B Thai; color: #ff6f37; margin: 5px;font-size: 16px; line-height: 1;'" >-</button>
                  <p>{{item.quantity}}</p>
                  <button @click="throttleAddToCart(item)" :style="'border-radius: 10px; height: 20px; width: 20px; background-color: #ff6f37; font-family: Martian B Thai; color: #ffffff;margin: 5px;font-size: 16px; line-height: 1;'" >+</button>
                </div>
                <div :style="'cursor: pointer'" >
                  <i v-on:click.prevent="deleteItem(item)" class="fa fa-trash-o" :style="'padding-top: 10px'"  aria-hidden="true"></i>
                </div>
              </div>
            </td>
          </tr>
          </thead>
            <div :style="'display: flex; justify-content: space-around; align-items: center; padding: 10px; box-shadow: 1px -5px 15px -5px #e6e3e3;'">
              <div :style="' display: flex; flex-direction: column;'" >
                <span :style="'font-size: 16px;'" >{{ $t('subtotal') }}({{this.calculateTotalCartQuantity()}} {{ $t('items') }})</span>
                <span :style="'font-size: 12px;'" >{{ $t('taxAndShipping') }}</span>
                <span :style="'font-size: 16px'" v-if="loggedIn">${{calculateLocalSubtotal()}} </span>
              </div>
              <div :style="'width: 150px;'">
                <button @click="postCartItemsAndCheckout($event)" class="btn" >{{ $t('checkOut') }}</button>
              </div>
            </div>
          </div>
      </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import _ from 'lodash';
import Router from '../router/index';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";

export default {
  name: "cart",
  methods:  {
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('products', ['updateActiveProduct']),
    goToLogin() {
      this.$router.push('/login')
    },
    checkAuthentication(authCallback) {
      this.isAuthenticated = isUserAuthenticated(), authCallback;
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  updateItemCount(e, item) {
    e.preventDefault();
      if (isUserAuthenticated()) {
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
        this.deleteItem(item);
      } else {
        this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
        .then(() => {
          this.local = false;
          this.$store.dispatch('cart/getCart');
        });
      }
    } else {
      item.quantity = item.quantity - 1;
      if (item.quantity < 1) {
        this.deleteItem(item)
      }
      this.$store.dispatch('cart/updateLocalCart', item)
      .then(() => {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      })
    }
  },
    postCartItemsAndCheckout(e) {
      e.preventDefault();
      if (isUserAuthenticated()) {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.$router.push('/purchase');
      });
      } else {
        this.$router.push('/login');
      }
    },
    localTotalPrice(price, quantity) {
      return (price * quantity).toFixed(2);
    },
    handleCartProductImageClick(productNum) {
      this.$router.history.push(`/productdetails?productnum=${productNum}`);
    },
    calculateLocalSubtotal() {
      if (this.local) {
        let cost = 0;
         this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity;
          cost += itemPrice; 
        })
        return cost.toFixed(2);
      } else {
        return this.$store.state.cart.cartProductsList.TotalPrice.toFixed(2);
      }
    },
    calculateTotalCartQuantity() {
      let totalQuantity = 0;
      for (var i = 0; i < this.cartProductsList.length; i++) {
        totalQuantity += this.cartProductsList[i].quantity;
      }
      return totalQuantity;
    },
    addItemToLocalCart(e, item) {
      item.quantity = item.quantity + 1;
      this.$store.dispatch('cart/updateLocalCart', item)
      .then(() => {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      });
    }, 
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addToCart: function(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})  
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])      
        }
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ 
        name: 'productDetails', 
        query: { productNum: product.ProductNum 
      }})
      }
  },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated()) {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
       this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
       .then(() => {
         this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
       })
      })
    }
      this.clearPromoCode();
      this.clearCard();
      next();
  },
  data(){
    return{
      addressList: [],
      deliveryDate: undefined,
      deliveryTime: undefined,
      willCallLocation: undefined,
      warehouseList: [],
      billingAddressOpen: false,
      creditCardOpen: false,
      customerNote: '',
      orders: [],
      unpaidAmount: undefined,
      isBlocking: true,
      isCreditUsed: false,
      isLoadingWarehouseList: false,
      isLoadingAddressList: false,
      isLoadingSubmitOrder: false,
      pickUpTime: '',
      isAddressBookOpen: false,
      stepIndex: 0,
      width: 0,
      promoCode: '',
      validatedPromoCode: undefined,
      promoCodeIsValid: false,
      promoCodeMessage: '',
      isValidatingPromoCode: false,
      // selectedPaymentMethod: PAYMENT_OPTIONS.alipay,
      isCashAllowed: false,
      bypass: null,
      local: null,
    }
  },
  beforeMount() {
    if (isUserAuthenticated()) {
      this.local = false;
      this.$store.dispatch('cart/getCart');
    } else {
      this.local = true;
      this.$store.dispatch('cart/fetchCartProducts');
    }
  },
  mounted() {
  },
  computed: mapState({
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    loggedIn: state => state.auth.loggedIn,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    mobile: state => state.cart.mobile,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    addToCartLoading: state => state.cart.addToCartLoading,
  }),
  watch: {
    token: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== null || newVal !== undefined) {
        this.local = false;
         this.$store.dispatch('cart/getCart');
      } else {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      }
    },
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/cart.less";
</style>



// WEBPACK FOOTER //
// src/view/cart.vue